import { useQuery, useMutation } from '@tanstack/react-query';
import axios from 'axios';

const apiPrefix = window.location.hostname === 'localhost' ? '' : '/api';
const get = (url) => axios.get(`${apiPrefix}${url}`, { withCredentials: true }).then(r => r.data);

export const useJobRuns = () => useQuery({
    queryKey: ['admin', 'job-runs'],
    queryFn: () => get('/admin/job-runs'),
});

export const useWorkerErrors = () => useQuery({
    queryKey: ['admin', 'worker-errors'],
    queryFn: () => get('/admin/worker-errors'),
});

export const useEmailQuota = () => useQuery({
    queryKey: ['admin', 'email-quota'],
    queryFn: () => get('/admin/email-quota'),
});

export const usePortalHealth = () => useQuery({
    queryKey: ['admin', 'portal-health'],
    queryFn: () => get('/admin/portal-health'),
});

export const useScrapflyUsage = () => useQuery({
    queryKey: ['admin', 'scrapfly-usage'],
    queryFn: () => get('/admin/scrapfly-usage'),
});

export const useAlertFirings = () => useQuery({
    queryKey: ['admin', 'alert-firings'],
    queryFn: () => get('/admin/alert-firings'),
});

export const useDiscoveryStats = () => useQuery({
    queryKey: ['admin', 'discovery-stats'],
    queryFn: () => get('/admin/discovery-stats'),
});

export const useEmailLog = (params = {}) => useQuery({
    queryKey: ['admin', 'email-log', params],
    queryFn: () => {
        const searchParams = new URLSearchParams();
        if (params.page) searchParams.set('page', params.page);
        if (params.per_page) searchParams.set('per_page', params.per_page);
        if (params.date_from) searchParams.set('date_from', params.date_from);
        if (params.date_to) searchParams.set('date_to', params.date_to);
        const qs = searchParams.toString();
        return get(`/admin/email-log${qs ? '?' + qs : ''}`);
    },
});

export const useTriggerScraper = () => useMutation({
    mutationFn: () => axios.post(`${apiPrefix}/admin/trigger-scraper`, {}, { withCredentials: true }).then(r => r.data),
});

export const useTriggerScheduledSearches = () => useMutation({
    mutationFn: () => axios.post(`${apiPrefix}/admin/trigger-scheduled-searches`, {}, { withCredentials: true }).then(r => r.data),
});

export const useBriefingStats = () => useQuery({
    queryKey: ['admin', 'briefing-stats'],
    queryFn: () => get('/admin/briefing-stats'),
});

export const useBriefingRuns = () => useQuery({
    queryKey: ['admin', 'briefing-runs'],
    queryFn: () => get('/admin/briefing-runs'),
});

export const useSmartAlertRuns = () => useQuery({
    queryKey: ['admin', 'smart-alert-runs'],
    queryFn: () => get('/admin/smart-alert-runs'),
});
